export const projectModelCode = projectId => `improvement-project:${projectId}`;

export const versionIdOf = version => version?.id ?? version?.version_id ?? null;

export const activePrimaryBinding = bindings => (Array.isArray(bindings) ? bindings : [])
  .find(binding => binding?.purpose === 'primary' && Boolean(binding?.is_active));

export const findProjectModel = (models, projectId) => (Array.isArray(models) ? models : [])
  .find(model => model?.code === projectModelCode(projectId));

export const draftOf = model => (model?.versions || []).find(version => version?.status === 'draft') || null;

export const latestPublishedOf = model => (model?.versions || [])
  .filter(version => version?.status === 'published')
  .sort((left, right) => Number(right.version_number || 0) - Number(left.version_number || 0))[0] || null;

const displayText = value => {
  if (value == null) return '';
  if (typeof value === 'string' || typeof value === 'number') return String(value);
  if (typeof value === 'object') return displayText(value.name ?? value.label ?? value.value);
  return '';
};

export const outputNamesFromGraph = graph => (graph?.nodes || [])
  .filter(node => node?.type === 'output.number')
  .map(node => displayText(node?.name) || displayText(node?.config_json?.key))
  .filter(Boolean);
